import { Component } from '@angular/core';
import * as moment from 'moment';
import { ViewbalanceService } from './viewbalance-lookup.service';
import { AlertService } from 'sce-core';
import { ResourceService } from 'sce-core';
import { CustomPaginationService } from '../../components/custom-pagination/custom-pagination.service';
import { ConfirmDialogService } from 'sce-core';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'lfwms-view-balance-lookup',
  templateUrl: './viewbalance-lookup.component.html',
  styleUrls: ['./viewbalance-lookup.component.css']
})
export class ViewbalanceLookupComponent {

  private pagesize: number = 16;
  private listPerPage: any[] = [];
  private viewBalanceData: any;
  private start_index: number;
  private end_index: number;
  private errorMessage: string;
  private adduserDisabled: boolean = true;
  private asnNumber: string = '';
  private asnLineNumber: string = '';
  private rows = [];
  private temp = [];
  private sortOrder: number = -1;
  private dataPerPage = 10;
  public showLookup: boolean = false;
  private storerKey: string = '';
  private commodity: string = '';
  public title: string;
  public type: string;
  public list: any[] = [];
  public columnDef: any[];
  public subHeading: boolean = true;
  public isTotalAvailable: boolean = false;

  public paginatorService: CustomPaginationService;
  public pageList = [10, 20, 50, 100];
  public recordCount: number = 0;
  public selectedRowsPerPage: number = 10;
  public state = {
    page: 1,
    first: 1,
    rows: [],
    pageCount: this.recordCount
  };
  public currentPage: number = 1;
  public pageSize: number = 10;


  public totalQty: any;
  public totalQtyPreAllocated: any;
  public totalQtyAllocated: any;
  public totalQtyPicked: any;
  public totalCaseCount: any;
  public totalInnerPack: any;
  public totalPallet: any;
  public totalCube: any;
  public totalGrossWeight: any;
  public totalNetWeight: any;
  public totalOtherUnit1: any;
  public totalOtherUnit2: any;

  public totalCapacityUnits: any;
  public totalCapacityMinimum: any;
  public totalQtyExpected: any;
  public totalQtyPickInProgress: any;


/*The variable 'page' is used to switch between 'ShowZeroBalances' and 'HideZeroBalances' based on the boolean value assigned  */
  public page: boolean = true;
  public toggletitle: string = this.getLabel('btn_ShowZero_bal');
  public data: any[]; // used to store the table data
  public num: number = 1;
  public pageSelectorOdd: number;
  public pageSelectorEven: number;
/*variables used for view Balnce filter*/

  constructor(public modalService: ModalService, private alertService: AlertService,
    private viewbalanceService: ViewbalanceService,
    protected resourceService: ResourceService, private confirmDialogService: ConfirmDialogService
  ) {
    this.paginatorService = new CustomPaginationService(this.confirmDialogService, this.resourceService);
    this.paginatorService.rows = this.selectedRowsPerPage;
    this.paginatorService.tableMode = 'V';
    this.pageSelection();
  }


  // On button click this function will be called , and will help to toggle between zero_balance and lot_balance
  public pageSelection() {

    this.page = this.page ? false : true;
    if (this.page === false) {
      this.toggletitle = this.getLabel('btn_ShowZero_bal');
    } else {
      this.toggletitle = this.getLabel('btn_HideZero_bal');
    }

    this.initializeComponent(this.data);
  }


  // method used to translate the labels
  public getLabel(key: any) {
    return this.resourceService.get(key);
  }
  public initializeComponent(viewBalance: any) {

    this.data = viewBalance;

    if (this.type) {
      this.columnDef = this.viewbalanceService.getColumnDataForType(this.type);
    }
    if ((this.type === 'InventoryTransaction' || this.type === 'ShowTransaction' ||
      this.type === 'InventoryLineTransaction' )) {
      this.subHeading = false;
    }

    if (viewBalance) {
      if (viewBalance.errors && viewBalance.errors.length > 0) {
        this.alertService.error(this.resourceService.translateServerResponse(viewBalance.errors[0].validationMessage));

      } else {
        this.getAllViewBalance(viewBalance);

      }
    }
  }

  // Note:  <i></i> tag will be removed once re-do of the screen have done

  public sortProperty(property: any, isAscending: any) {

    const ltVal = isAscending ? -1 : 1;
    const gtVal = isAscending ? 1 : -1;
    this.rows.sort((a: any, b: any) => {
      if (a[property] < b[property]) {
        return ltVal;
      } else {
        return gtVal;
      }
    });
  }

  public toggleColumnSort(column: any) {

    let currentSortOrder: number = column.sortOrder;
    if ((currentSortOrder === -1) || (currentSortOrder === 0)) {
      this.rows.sort((a: any, b: any) => {
        if (column.type === 'string') {
          return (a[column.prop].toLowerCase() > b[column.prop].toLowerCase()) ?
            -1 : ((b[column.prop].toLowerCase() > a[column.prop].toLowerCase()) ? 1 : 0);
        } else if (column.type === 'number') {
          return (a[column.prop] > b[column.prop]) ? -1 : ((b[column.prop] > a[column.prop]) ? 1 : 0);
        } else {
          let aDate: string = '';
          let bDate: string = '';
          if (a[column.prop]) {
            aDate = moment(a[column.prop]).format('DDMMYYYY hh:mm A');
          }
          if (b[column.prop]) {
            bDate = moment(b[column.prop]).format('DDMMYYYY hh:mm A');
          }
          return (aDate > bDate) ? -1 : ((bDate > aDate) ? 1 : 0);
        }
      });
      currentSortOrder = 1;
    } else if (currentSortOrder === 1) {
      this.rows.sort((a: any, b: any) => {
        if (column.type === 'string') {
          return (a[column.prop].toLowerCase() > b[column.prop].toLowerCase()) ?
            1 : ((b[column.prop].toLowerCase() > a[column.prop].toLowerCase()) ? -1 : 0);
        } else if (column.type === 'number') {
          return (a[column.prop] > b[column.prop]) ? 1 : ((b[column.prop] > a[column.prop]) ? -1 : 0);
        } else {
          let aDate: string = '';
          let bDate: string = '';
          if (a[column.prop]) {
            aDate = moment(a[column.prop]).format('DDMMYYYY hh:mm A');
          }
          if (b[column.prop]) {
            bDate = moment(b[column.prop]).format('DDMMYYYY hh:mm A');
          }
          return (aDate > bDate) ? 1 : ((bDate > aDate) ? -1 : 0);
        }
      });
      currentSortOrder = 0;
    }
    this.columnDef.forEach((col: any) => {
      if (col.prop !== column.property) {
        col.sortOrder = -1;
      }
    });
    this.listPerPage = this.rows.slice(this.start_index, this.end_index);
    if (this.type === 'LotBalance') {
      this.listPerPage.push({
        'lot': 'TOTAL',
        'qty': this.totalQty,
        'qtyPreallocated': this.totalQtyPreAllocated,
        'qtyAllocated': this.totalQtyAllocated,
        'qtyPicked': this.totalQtyPicked,
        'casecnt': this.totalCaseCount,
        'innerPack': this.totalInnerPack,
        'pallet': this.totalPallet,
        'cube': this.totalCube,
        'grossWgt': this.totalGrossWeight,
        'netWgt': this.totalNetWeight,
        'otherUnit1': this.totalOtherUnit1,
        'otherUnit2': this.totalOtherUnit2
      });
    } else if (this.type === 'LotLocMovableUnit') {
      this.listPerPage.push({
        'lot': 'TOTAL',
        'qty': this.totalQty,
        'qtyAllocated': this.totalQtyAllocated,
        'qtyPicked': this.totalQtyPicked,
        'qtyExpected': this.totalQtyExpected,
        'qtyPickinProcess': this.totalQtyPickInProgress
      });
    } else if (this.type === 'CommodityLoc') {
      this.listPerPage.push({
        'locationType': 'TOTAL',
        'qty': this.totalQty,
        'qtyLocationLimit': this.totalCapacityUnits,
        'qtyLocationMinimum': this.totalCapacityMinimum,
        'qtyAllocated': this.totalQtyAllocated,
        'qyPicked': this.totalQtyPicked,
        'qtyExpected': this.totalQtyExpected,
        'qtyPickInProcess': this.totalQtyPickInProgress
      });
    }
    column.sortOrder = currentSortOrder;
  }

  public sortByColumn(evt: any) {

    const isAscending = (evt.newValue === 'asc');
    this.sortProperty(evt.column.prop, isAscending);
    this.listPerPage = [];
    this.listPerPage = this.rows.slice(this.start_index, this.end_index);
    if (this.type === 'LotBalance') {
      this.listPerPage.push({
        'lot': 'TOTAL',
        'qty': this.totalQty,
        'qtyPreallocated': this.totalQtyPreAllocated,
        'qtyAllocated': this.totalQtyAllocated,
        'qtyPicked': this.totalQtyPicked,
        'casecnt': this.totalCaseCount,
        'innerPack': this.totalInnerPack,
        'pallet': this.totalPallet,
        'cube': this.totalCube,
        'grossWgt': this.totalGrossWeight,
        'netWgt': this.totalNetWeight,
        'otherUnit1': this.totalOtherUnit1,
        'otherUnit2': this.totalOtherUnit2
      });
    } else if (this.type === 'LotLocMovableUnit') {
      this.listPerPage.push({
        'lot': 'TOTAL',
        'qty': this.totalQty,
        'qtyAllocated': this.totalQtyAllocated,
        'qtyPicked': this.totalQtyPicked,
        'qtyExpected': this.totalQtyExpected,
        'qtyPickinProcess': this.totalQtyPickInProgress
      });
    } else if (this.type === 'CommodityLoc') {
      this.listPerPage.push({
        'locationType': 'TOTAL',
        'qty': this.totalQty,
        'qtyLocationLimit': this.totalCapacityUnits,
        'qtyLocationMinimum': this.totalCapacityMinimum,
        'qtyAllocated': this.totalQtyAllocated,
        'qyPicked': this.totalQtyPicked,
        'qtyExpected': this.totalQtyExpected,
        'qtyPickInProcess': this.totalQtyPickInProgress
      });
    }
  }

  public getAllViewBalance(viewBalance: any) {

    this.rows = [];
    this.start_index = 0;
    this.end_index = 10;
    this.pageSelectorOdd = 0;
    this.pageSelectorEven = 0;
    this.viewBalanceData = viewBalance;
    /*Lot Balance  */
    this.totalQty = 0;
    this.totalQtyPreAllocated = 0;
    this.totalQtyAllocated = 0;
    this.totalQtyPicked = 0;
    this.totalCaseCount = 0;
    this.totalInnerPack = 0;
    this.totalPallet = 0;
    this.totalCube = 0;
    this.totalGrossWeight = 0;
    this.totalNetWeight = 0;
    this.totalOtherUnit1 = 0;
    this.totalOtherUnit2 = 0;
    /* Commodity-Loc */
    this.totalCapacityUnits = 0;
    this.totalCapacityMinimum = 0;
    this.totalQtyExpected = 0;
    this.totalQtyPickInProgress = 0;


    // Sorting of data fetched is done based on the conditions like qty=0 or not
    if (this.type === 'LotBalance') {
      this.viewBalanceData.commodityLot.forEach(entry => {

        if (this.toggletitle === 'Hide Zero Balances') {

          this.rows.push(entry);

          this.pageSelectorOdd = this.pageSelectorOdd + 1;

          this.totalQty = this.totalQty + entry.qty;
          this.totalQtyPreAllocated = this.totalQtyPreAllocated + entry.qtyPreallocated;
          this.totalQtyAllocated = this.totalQtyAllocated + entry.qtyAllocated;
          this.totalQtyPicked = this.totalQtyPicked + entry.qtyPicked;
          this.totalCaseCount = this.totalCaseCount + entry.casecnt;
          this.totalInnerPack = this.totalInnerPack + entry.innerPack;
          this.totalPallet = this.totalPallet + entry.pallet;
          this.totalCube = this.totalCube + entry.cube;
          this.totalGrossWeight = this.totalGrossWeight + entry.grossWgt;
          this.totalNetWeight = this.totalNetWeight + entry.netWgt;
          this.totalOtherUnit1 = this.totalOtherUnit1 + entry.otherUnit1;
          this.totalOtherUnit2 = this.totalOtherUnit2 + entry.otherUnit2;
        } else {
          if ((entry.qty) > 0) {
            this.rows.push(entry);
            this.pageSelectorEven = this.pageSelectorEven + 1;

            this.totalQty = this.totalQty + entry.qty;
            this.totalQtyPreAllocated = this.totalQtyPreAllocated + entry.qtyPreallocated;
            this.totalQtyAllocated = this.totalQtyAllocated + entry.qtyAllocated;
            this.totalQtyPicked = this.totalQtyPicked + entry.qtyPicked;
            this.totalCaseCount = this.totalCaseCount + entry.casecnt;
            this.totalInnerPack = this.totalInnerPack + entry.innerPack;
            this.totalPallet = this.totalPallet + entry.pallet;
            this.totalCube = this.totalCube + entry.cube;
            this.totalGrossWeight = this.totalGrossWeight + entry.grossWgt;
            this.totalNetWeight = this.totalNetWeight + entry.netWgt;
            this.totalOtherUnit1 = this.totalOtherUnit1 + entry.otherUnit1;
            this.totalOtherUnit2 = this.totalOtherUnit2 + entry.otherUnit2;
          }
        }
      });

      if (this.toggletitle === 'Hide Zero Balances') {
        this.recordCount = this.pageSelectorOdd;
      } else {
        this.recordCount = this.pageSelectorEven;
      }
      this.commodity = this.viewBalanceData.commodityLot[0].sku;
      this.storerKey = this.viewBalanceData.commodityLot[0].storerKey;
      this.paginatorService.totalRecords = this.recordCount;
      this.paginatorService.choosenPage = this.currentPage;
      this.paginatorService.paginatorState = this.state;
      this.paginatorService.rowsPerPageOptions = this.pageList;
      this.paginatorService.pageLinkSize = 5;
      this.paginatorService.getPaginatorBroadcast()
        .subscribe((event: any) => {
          this.state = event;
          this.start_index = (this.state.page * this.paginatorService.rows) - this.paginatorService.rows;
          this.end_index = ((this.state.page * this.paginatorService.rows) + this.paginatorService.rows) - this.paginatorService.rows;
          this.listPerPage = [];
          this.listPerPage = this.rows.slice(this.start_index, this.end_index);
          this.listPerPage.push({
            'lot': 'TOTAL',
            'qty': this.totalQty,
            'qtyPreallocated': this.totalQtyPreAllocated,
            'qtyAllocated': this.totalQtyAllocated,
            'qtyPicked': this.totalQtyPicked,
            'casecnt': this.totalCaseCount,
            'innerPack': this.totalInnerPack,
            'pallet': this.totalPallet,
            'cube': this.totalCube,
            'grossWgt': this.totalGrossWeight,
            'netWgt': this.totalNetWeight,
            'otherUnit1': this.totalOtherUnit1,
            'otherUnit2': this.totalOtherUnit2
          });
        });
      this.paginatorService.changePageToFirst(event);
      this.start_index = (1 * this.paginatorService.rows) - this.paginatorService.rows;
      this.end_index = ((1 * this.paginatorService.rows) + this.paginatorService.rows) - this.paginatorService.rows;
      this.listPerPage = [];
      this.listPerPage = this.rows.slice(this.start_index, this.end_index);
      this.listPerPage.push({
        'lot': 'TOTAL',
        'qty': this.totalQty,
        'qtyPreallocated': this.totalQtyPreAllocated,
        'qtyAllocated': this.totalQtyAllocated,
        'qtyPicked': this.totalQtyPicked,
        'casecnt': this.totalCaseCount,
        'innerPack': this.totalInnerPack,
        'pallet': this.totalPallet,
        'cube': this.totalCube,
        'grossWgt': this.totalGrossWeight,
        'netWgt': this.totalNetWeight,
        'otherUnit1': this.totalOtherUnit1,
        'otherUnit2': this.totalOtherUnit2
      });


    } else if (this.type === 'LotLocMovableUnit') {
      this.viewBalanceData.commodityMov.forEach(entry => {

        if (this.toggletitle === 'Hide Zero Balances') {

          this.rows.push(entry);
          this.pageSelectorOdd = this.pageSelectorOdd + 1;

          this.totalQty = this.totalQty + entry.qty;
          this.totalQtyAllocated = this.totalQtyAllocated + entry.qtyAllocated;
          this.totalQtyPicked = this.totalQtyPicked + entry.qyPicked;
          this.totalQtyExpected = this.totalQtyExpected + entry.qtyExpected;
          this.totalQtyPickInProgress = this.totalQtyPickInProgress + entry.qtyPickInProgress;


        } else {
          if ((entry.qty) > 0 && (entry.qtyExpected > 0)) {
            this.rows.push(entry);
            this.pageSelectorEven = this.pageSelectorEven + 1;

            this.totalQty = this.totalQty + entry.qty;
            this.totalQtyAllocated = this.totalQtyAllocated + entry.qtyAllocated;
            this.totalQtyPicked = this.totalQtyPicked + entry.qyPicked;
            this.totalQtyExpected = this.totalQtyExpected + entry.qtyExpected;
            this.totalQtyPickInProgress = this.totalQtyPickInProgress + entry.qtyPickInProgress;
          }
        }
      });
      if (this.toggletitle === 'Hide Zero Balances') {
        this.recordCount = this.pageSelectorOdd;
      } else {
        this.recordCount = this.pageSelectorEven;

      }
      this.commodity = this.viewBalanceData.commodityMov[0].sku;
      this.storerKey = this.viewBalanceData.commodityMov[0].storerKey;
      this.paginatorService.totalRecords = this.recordCount;
      this.paginatorService.choosenPage = this.currentPage;
      this.paginatorService.paginatorState = this.state;
      this.paginatorService.rowsPerPageOptions = this.pageList;
      this.paginatorService.pageLinkSize = 5;
      this.paginatorService.getPaginatorBroadcast()
        .subscribe((event: any) => {
          this.state = event;
          this.start_index = (this.state.page * this.paginatorService.rows) - this.paginatorService.rows;
          this.end_index = ((this.state.page * this.paginatorService.rows) + this.paginatorService.rows) - this.paginatorService.rows;
          this.listPerPage = [];
          this.listPerPage = this.rows.slice(this.start_index, this.end_index);
          this.listPerPage.push({
            'lot': 'TOTAL',
            'qty': this.totalQty,
            'qtyAllocated': this.totalQtyAllocated,
            'qtyPicked': this.totalQtyPicked,
            'qtyExpected': this.totalQtyExpected,
            'qtyPickinProcess': this.totalQtyPickInProgress
          });
        });
      this.paginatorService.changePageToFirst(event);
      this.start_index = (1 * this.paginatorService.rows) - this.paginatorService.rows;
      this.end_index = ((1 * this.paginatorService.rows) + this.paginatorService.rows) - this.paginatorService.rows;
      this.listPerPage = [];
      this.listPerPage = this.rows.slice(this.start_index, this.end_index);
      this.listPerPage.push({
        'lot': 'TOTAL',
        'qty': this.totalQty,
        'qtyAllocated': this.totalQtyAllocated,
        'qtyPicked': this.totalQtyPicked,
        'qtyExpected': this.totalQtyExpected,
        'qtyPickinProcess': this.totalQtyPickInProgress
      });
    } else if (this.type === 'CommodityLoc') {
      this.viewBalanceData.commodityLoc.forEach(entry => {

        if (this.toggletitle === 'Hide Zero Balances') {

          this.rows.push(entry);
          this.pageSelectorOdd = this.pageSelectorOdd + 1;

          this.totalQty = this.totalQty + entry.qty;
          this.totalQtyAllocated = this.totalQtyAllocated + entry.qtyAllocated;
          this.totalQtyPicked = this.totalQtyPicked + entry.qyPicked;
          this.totalCapacityUnits = this.totalCapacityUnits + entry.qtyLocationLimit;
          this.totalCapacityMinimum = this.totalCapacityMinimum + entry.qtyLocationMinimum;
          this.totalQtyPickInProgress = this.totalQtyPickInProgress + entry.qtyPickInProcess;
          this.totalQtyExpected = this.totalQtyExpected + entry.qtyExpected;


        } else {
          if (((entry.qty) > 0 && (entry.qtyExpected > 0))) {
            this.rows.push(entry);
            this.pageSelectorEven = this.pageSelectorEven + 1;

            this.totalQty = this.totalQty + entry.qty;
            this.totalQtyAllocated = this.totalQtyAllocated + entry.qtyAllocated;
            this.totalQtyPicked = this.totalQtyPicked + entry.qyPicked;
            this.totalCapacityUnits = this.totalCapacityUnits + entry.qtyLocationLimit;
            this.totalCapacityMinimum = this.totalCapacityMinimum + entry.qtyLocationMinimum;
            this.totalQtyPickInProgress = this.totalQtyPickInProgress + entry.qtyPickInProcess;
            this.totalQtyExpected = this.totalQtyExpected + entry.qtyExpected;
          }
        }
      });
      if (this.toggletitle === 'Hide Zero Balances') {
        this.recordCount = this.pageSelectorOdd;
      } else {
        this.recordCount = this.pageSelectorEven;

      }
      this.commodity = this.viewBalanceData.commodityLoc[0].sku;
      this.storerKey = this.viewBalanceData.commodityLoc[0].storerKey;
      this.paginatorService.totalRecords = this.recordCount;
      this.paginatorService.choosenPage = this.currentPage;
      this.paginatorService.paginatorState = this.state;
      this.paginatorService.rowsPerPageOptions = this.pageList;
      this.paginatorService.pageLinkSize = 5;
      this.paginatorService.getPaginatorBroadcast()
        .subscribe((event: any) => {
          this.state = event;
          this.start_index = (this.state.page * this.paginatorService.rows) - this.paginatorService.rows;
          this.end_index = ((this.state.page * this.paginatorService.rows) + this.paginatorService.rows) - this.paginatorService.rows;
          this.listPerPage = [];
          this.listPerPage = this.rows.slice(this.start_index, this.end_index);
          this.listPerPage.push({
            'locationType': 'TOTAL',
            'qty': this.totalQty,
            'qtyLocationLimit': this.totalCapacityUnits,
            'qtyLocationMinimum': this.totalCapacityMinimum,
            'qtyAllocated': this.totalQtyAllocated,
            'qyPicked': this.totalQtyPicked,
            'qtyExpected': this.totalQtyExpected,
            'qtyPickInProcess': this.totalQtyPickInProgress
          });
        });
      this.paginatorService.changePageToFirst(event);
      this.start_index = (1 * this.paginatorService.rows) - this.paginatorService.rows;
      this.end_index = ((1 * this.paginatorService.rows) + this.paginatorService.rows) - this.paginatorService.rows;
      this.listPerPage = [];
      this.listPerPage = this.rows.slice(this.start_index, this.end_index);
      this.listPerPage.push({
        'locationType': 'TOTAL',
        'qty': this.totalQty,
        'qtyLocationLimit': this.totalCapacityUnits,
        'qtyLocationMinimum': this.totalCapacityMinimum,
        'qtyAllocated': this.totalQtyAllocated,
        'qyPicked': this.totalQtyPicked,
        'qtyExpected': this.totalQtyExpected,
        'qtyPickInProcess': this.totalQtyPickInProgress
      });
    } else if (this.type === 'InventoryTransaction') {
      if (this.viewBalanceData.invTrans) {
        this.rows = this.viewBalanceData.invTrans;
        this.recordCount = this.viewBalanceData.invTrans.length;
        this.paginatorService.totalRecords = this.recordCount;
        this.paginatorService.choosenPage = this.currentPage;
        this.paginatorService.paginatorState = this.state;
        this.paginatorService.rowsPerPageOptions = this.pageList;
        this.paginatorService.pageLinkSize = 5;
        this.paginatorService.getPaginatorBroadcast()
          .subscribe((event: any) => {
            this.state = event;
            this.start_index = (this.state.page * this.paginatorService.rows) - this.paginatorService.rows;
            this.end_index = ((this.state.page * this.paginatorService.rows) + this.paginatorService.rows) - this.paginatorService.rows;
            this.listPerPage = [];
            this.listPerPage = this.rows.slice(this.start_index, this.end_index);
          });
        this.listPerPage = this.rows.slice(this.start_index, this.end_index);
      } else {
        this.listPerPage = this.rows.slice(this.start_index, this.end_index);
      }
    } else if (this.type === 'InventoryLineTransaction' || this.type === 'ShowTransaction') {
      if (this.viewBalanceData.invTrans) {
        this.rows = this.viewBalanceData.invTrans;
        this.recordCount = this.viewBalanceData.invTrans.length;
        this.paginatorService.totalRecords = this.recordCount;
        this.paginatorService.choosenPage = this.currentPage;
        this.paginatorService.paginatorState = this.state;
        this.paginatorService.rowsPerPageOptions = this.pageList;
        this.paginatorService.pageLinkSize = 5;
        this.paginatorService.getPaginatorBroadcast()
          .subscribe((event: any) => {
            this.state = event;
            this.start_index = (this.state.page * this.paginatorService.rows) - this.paginatorService.rows;
            this.end_index = ((this.state.page * this.paginatorService.rows) + this.paginatorService.rows) - this.paginatorService.rows;
            this.listPerPage = [];
            this.listPerPage = this.rows.slice(this.start_index, this.end_index);
          });
        this.listPerPage = this.rows.slice(this.start_index, this.end_index);
      } else {
        this.currentPage = 1;
        this.recordCount = 0;
        this.paginatorService.totalRecords = this.recordCount;
        this.paginatorService.choosenPage = this.currentPage;
        this.listPerPage = this.rows.slice(this.start_index, this.end_index);
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/viewbalance-lookup/viewbalance-lookup.component.ts